export default __webpack_public_path__ + "static/media/nieWieder.4c6ac02d.png";